var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aInProgress{fill:#db7e00;}.bInProgress,.cInProgress{fill:#fff;}.cInProgress{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1573 -722)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aInProgress",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1573 722)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1574.277 724.773)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bInProgress",
    d: "M10.087,6.889h3.426a.218.218,0,0,1,.167.357L11.967,9.3a.218.218,0,0,1-.335,0L9.92,7.247a.218.218,0,0,1,.167-.357ZM.5,8.632H3.928A.218.218,0,0,0,4.1,8.275L2.382,6.218a.218.218,0,0,0-.335,0L.335,8.275A.218.218,0,0,0,.5,8.632Z",
    transform: "translate(-0.284 -2.534)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cInProgress",
    d: "M7.239,2.872A4.347,4.347,0,0,0,3.878,4.456.436.436,0,1,1,3.206,3.9a5.23,5.23,0,0,1,9.189,2.456h-.886a4.359,4.359,0,0,0-4.27-3.486ZM2.969,8.1A4.359,4.359,0,0,0,10.6,10a.436.436,0,1,1,.672.554A5.23,5.23,0,0,1,2.083,8.1Z",
    transform: "translate(-0.515 -2.002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInProgress);
export default __webpack_public_path__ + "static/media/icon_in_progress.3a8860030c870c4bc8c0e33cf0427fc4.svg";
export { ForwardRef as ReactComponent };